import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Cake, Gift } from "lucide-react";

export default function RemindersPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/reminders").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-3 sm:p-6 lg:p-10 max-w-full">
      <header className="mb-6">
        <p className="label-eyebrow">Auto-alerts</p>
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Upcoming this week</h1>
        <p className="text-gray-500 mt-1">All personnel are notified 7 days before each event.</p>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((r, i) => (
          <Card key={i} className="p-5" data-testid={`reminder-${r.client_id}-${r.type}`}>
            <div className="flex items-center gap-2 mb-2">
              {r.type === "birthday" ? <Cake size={16} className="text-pink-500" /> : <Gift size={16} className="text-purple-500" />}
              <span className="label-eyebrow">{r.type}</span>
            </div>
            <div className="text-2xl font-semibold">{r.client_name}</div>
            <div className="text-sm text-gray-500 mt-1">{r.date} · in {r.days_until} {r.days_until === 1 ? "day" : "days"}</div>
          </Card>
        ))}
        {items.length === 0 && <p className="text-gray-400 col-span-full">No reminders within the next 7 days.</p>}
      </div>
    </div>
  );
}
